// plugins/vue-infinite-scroll.js

import Vue from "vue";
import InfiniteScroll from "vue-infinite-scroll";

Vue.use(InfiniteScroll);
